import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/seasons/detail.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var QUEUE_SESSION_HEADER = "queue-token";
var getSeasonBySlug = (_0) => __async(null, [_0], function* ({
  slug,
  lang = ""
}) {
  var _a, _b;
  try {
    const params = new URLSearchParams();
    const locale = getLocaleOnly(lang);
    params.append("lang", locale);
    params.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    const response = yield fetchClient({
      url: `/season-detail/${slug}?${params.toString()}`,
      queue: slug,
      raw: true
    });
    const sessionId = response.headers.get(QUEUE_SESSION_HEADER) || "";
    const data = yield response.json();
    if (!response.ok) {
      if (!data.message) {
        data.message = (data == null ? void 0 : data.error) || "Something went wrong";
      }
      data.statusCode = response.status;
      throw data;
    }
    const season = data.data;
    if (!season) {
      return null;
    }
    season.ticket_packages = season.ticket_packages.map((bundle) => __spreadProps(__spreadValues({}, bundle), {
      event_tickets: bundle.season_tickets
    }));
    return __spreadProps(__spreadValues({}, season), {
      _queue: data._queue,
      sessionId
    });
  } catch (error) {
    throw new Exception({ error, name: "getSeasonBySlugException" });
  }
});
var getPrivateSeasonBySlug = (_0) => __async(null, [_0], function* ({ slug, lang }) {
  var _a, _b;
  try {
    const params = new URLSearchParams();
    const locale = getLocaleOnly(lang);
    params.append("lang", locale);
    params.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    params.append("visibility", "private");
    const response = yield fetchClient({
      url: `/season-detail/${slug}?${params.toString()}`,
      queue: slug,
      raw: true
    });
    const sessionId = response.headers.get(QUEUE_SESSION_HEADER) || "";
    const data = yield response.json();
    if (!response.ok) {
      if (!data.message) {
        data.message = (data == null ? void 0 : data.error) || "Something went wrong";
      }
      data.statusCode = response.status;
      throw data;
    }
    return __spreadProps(__spreadValues({}, data.data), {
      _queue: data._queue,
      sessionId
    });
  } catch (error) {
    throw new Exception({
      error,
      name: "getPrivateSeasonBySlugException"
    });
  }
});
var getAccessibilitySeasonBySlug = (_0) => __async(null, [_0], function* ({
  slug,
  lang = ""
}) {
  var _a, _b;
  try {
    const params = new URLSearchParams();
    const locale = getLocaleOnly(lang);
    params.append("lang", locale);
    params.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    const response = yield fetchClient({
      url: `/season-detail/${slug}/accessibility?${params.toString()}`,
      queue: slug,
      raw: true
    });
    const sessionId = response.headers.get(QUEUE_SESSION_HEADER) || "";
    const data = yield response.json();
    if (!response.ok) {
      if (!data.message) {
        data.message = (data == null ? void 0 : data.error) || "Something went wrong";
      }
      data.statusCode = response.status;
      throw data;
    }
    const season = data.data;
    if (!season) {
      return null;
    }
    season.ticket_packages = season.ticket_packages.map((bundle) => __spreadProps(__spreadValues({}, bundle), {
      event_tickets: bundle.season_tickets
    }));
    return __spreadProps(__spreadValues({}, season), {
      _queue: data._queue,
      sessionId
    });
  } catch (error) {
    throw new Exception({ error, name: "getAccessibilitySeasonBySlugException" });
  }
});

export {
  getSeasonBySlug,
  getPrivateSeasonBySlug,
  getAccessibilitySeasonBySlug
};
//# sourceMappingURL=chunk-EW3JJYGP.mjs.map